import React from "react";
import ReactECharts from 'echarts-for-react';

const option = {
    title: {
        text: 'Card View Performance',
        subtext: '',
        left: 'center',
        textStyle: {
            fontSize: 14, 
            fontWeight: 'normal', 
            color: '#2E2E30' 
        }
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct']
    },
    yAxis: {
        
        axisLabel: {
            formatter: '{value} K'
        }
    },
    legend: {
        left: 'center',
        top: 'bottom',
        data: ['August', 'September'],
        padding: 15,
    },
    series: [{
        name: 'August',
        type: 'line',
        data: [1, 2, 4, 3, 6, 9, 7],
        areaStyle:{},
        color: '#FFC774'
        
     },
     {
        name: 'September',
        type: 'line',
        data: [6, 4, 3, 4, 2, 9, 8],
        areaStyle:{},
        color: '#ADB7F9'
        
     }
    ]
}
const CardViewChart = () => {
    return (
        <div className='cart-chart-left top-card-chart'>
            <ReactECharts option={option} 
    opts={{renderer: 'svg'}} lazyUpdate={true}  style={{ height: '418px' }} />
        </div>
    );
}
export default CardViewChart;